import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import {EnvironmentService} from '../../services/environmentService';
import { JobsWhiteLabelAdminAPI } from '../../services/wladmin/jobsWhiteLabelAdminAPI';


@inject(AuthService, UserMessageService, Router, JobsWhiteLabelAdminAPI, EnvironmentService)
export class Jobs {
    constructor(authService, userMessageService, router, api, envService) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.api = api;
        this.envService = envService;


    }

    activate(params, route) {
        this.testimonial_id = params.testimonial_id;
        this.testimonial_type = route.settings.testimonial_type;
        this.dataList = null;
        this.count = null;
        this.limit = 10;
        this.page = 1;
        this.sortBy = "CREATE_TIME";
        this.sortDir = "DESC";
        this.running_only = true;

        this.load();

    }

    detached() {
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
    }




    load() {
        this.api.getList(
            this.testimonial_type,
            this.testimonial_id,
            this.running_only,
            this.page,
            this.limit,
            this.sortBy,
            this.sortDir,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    saveLoadSuccess(data) {
        this.setData(data);
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.refreshTimeout = setTimeout(this.load.bind(this), 10000);

    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData(data) {
        this.dataList = data.list;
        this.count = data.count;
        this.pages =  Math.floor(this.count / this.limit);
        this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
    }





    columnClicked(name) {
        if (this.sortBy == name) {
            if (this.sortDir == "ASC")
                this.sortDir = "DESC";
            else
                this.sortDir = "ASC";
            this.load();
        } else {
            this.sortBy = name;
            this.sortDir = "DESC";
            this.load();
        }
    }

    prev() {
        if (this.page > 1) {
            this.page--;
            this.dataList = null;
            this.load();
        }
    }

    next() {
        if (this.page < this.pages) {
            this.page++;
            this.dataList = null;
            this.load();
        }
    }


}
